import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import createSagaMiddleware from "redux-saga";
import { reduxBatch } from "@manaflair/redux-batch";
import { persistStore } from "redux-persist";
import { rootReducer, rootSaga } from "./rootReducer";
import { baseApi } from "./baseAPI";
import { problemApi } from "../app/redux/problemsService";
import { labApi } from "../app/redux/labService";
import { immunizationApi } from "../app/redux/immunizationService";
import { physicalExamApi } from "../app/redux/physicalExamService";
import { allergiesApi } from "../app/redux/allergiesService";
import { reconciliationsApi } from "../app/redux/reconciliationsService";
import { guidelinesApi } from "app/redux/guidelinesService";
import { utilitiesApi } from "app/redux/utilityService";
import { providerNoteApi } from "app/redux/providerNoteService";
import { fbApi } from "app/redux/fbService";
import { advanceDirectiveApi } from "app/redux/advanceDirectiveService";
import { eyeExamsApi } from "app/redux/eyeExamService";
import { tcmApi } from "app/redux/tcmService";

const sagaMiddleware = createSagaMiddleware();
const middleware = [
    ...getDefaultMiddleware({
        immutableCheck: false,
        serializableCheck: false,
        thunk: true,

    }),
    sagaMiddleware,
    baseApi.middleware,
    problemApi.middleware,
    labApi.middleware,
    advanceDirectiveApi.middleware,
    eyeExamsApi.middleware,
    immunizationApi.middleware,
    allergiesApi.middleware,
    reconciliationsApi.middleware,
    guidelinesApi.middleware,
    physicalExamApi.middleware,
    utilitiesApi.middleware,
    providerNoteApi.middleware,
    fbApi.middleware,
    tcmApi.middleware,
];

const store = configureStore({
    reducer: rootReducer,
    middleware,
    devTools: process.env.NODE_ENV !== "production",
    enhancers: [reduxBatch],
});

/**
 * @see https://github.com/rt2zz/redux-persist#persiststorestore-config-callback
 * @see https://github.com/rt2zz/redux-persist#persistor-object
 */
export const persistor = persistStore(store);

sagaMiddleware.run(rootSaga);

export default store;
